import { JURISDICTION_LIST } from '@/lib/constants';
import { useCreateCommercialProposal } from '@/models/commercial-proposal';
import {
  Box,
  Button,
  Divider,
  Flex,
  Modal,
  Select,
  TextInput,
} from '@mantine/core';
import { useForm } from '@mantine/form';
import { notifications } from '@mantine/notifications';
import { useState } from 'react';

export default function CreateProposal({
  onCreated,
}: {
  onCreated: (id: number) => void;
}) {
  const [opened, setOpened] = useState(false);
  const { mutate: createCommercialProposal } = useCreateCommercialProposal();

  const form = useForm({
    mode: 'uncontrolled',
    initialValues: {
      name: '',
      jurisdiction: '',
      currency: 'EUR',
    },
    validate: {
      name: (value) =>
        value.length < 3 ? 'Name must be at least 3 characters long' : null,
      jurisdiction: (value) =>
        JURISDICTION_LIST.some(({ code }) => code === value)
          ? null
          : 'Invalid jurisdiction',
    },
  });

  return (
    <>
      <Modal
        opened={opened}
        onClose={() => setOpened(false)}
        title="Create Proposal"
      >
        <form
          onSubmit={form.onSubmit((values) => {
            createCommercialProposal(
              {
                name: values.name,
                jurisdiction: values.jurisdiction,
                currency: values.currency,
              },
              {
                onSuccess: (o) => {
                  setOpened(false);
                  notifications.show({
                    title: 'Proposal Created',
                    message: 'Proposal Created Successfully',
                    color: 'green',
                  });
                  onCreated(o.id);
                },
              },
            );
          })}
        >
          <Flex gap={'md'} p="md" direction="column">
            <TextInput
              size="xs"
              label="Proposal Name"
              key={form.key('name')}
              {...form.getInputProps('name')}
            />
            <Select
              size="xs"
              label="Jurisdiction"
              placeholder={'Select...'}
              searchable
              clearable={false}
              multiple={false}
              data={JURISDICTION_LIST.map(({ code, title }) => ({
                value: code,
                label: title,
              }))}
              key={form.key('jurisdiction')}
              {...form.getInputProps('jurisdiction')}
            />
            <Select
              size="xs"
              label="Currenc"
              placeholder={'Select...'}
              clearable={false}
              multiple={false}
              data={[
                { value: 'EUR', label: 'EUR (€)' },
                { value: 'USD', label: 'USD ($)' },
              ]}
              required
              key={form.key('currency')}
              {...form.getInputProps('currency')}
            />
          </Flex>
          <Divider />
          <Box p={'md'} ta={'right'}>
            <Button type="submit">Create Proposal</Button>
          </Box>
        </form>
      </Modal>
      <Flex justify={'right'}>
        <Button onClick={() => setOpened(true)} variant="light" size="xs">
          Create Proposal
        </Button>
      </Flex>
    </>
  );
}
